import axios from 'axios'

function escapeHtml (value) {
  return String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character])
}

function replaceBrandText (value, name, html = false) {
  // Preserve markup, CSS, URLs and addresses; replace only the standalone brand in text.
  const protectedContent = /<!--[\s\S]*?-->|<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>|<(?:"[^"]*"|'[^']*'|[^'">])*>|(?:https?:\/\/|www\.)[^\s<]+|[^\s<>]*@[^\s<>]+|\b[\w-]+(?:\.[\w-]+)+(?:\/[^\s<>]*)?|\bGarantePay\b/gi
  return String(value || '').replace(protectedContent, match => /^garantepay$/i.test(match)
    ? (html ? escapeHtml(name) : name)
    : match)
}

export function buildGuarantorEmail (email, brand, apiBase, publicOrigin, defaultReply) {
  const name = String(brand?.garNomeEmpresa || '').trim()
  if (!name) throw new Error('Não foi possível identificar o nome da garantidora para o e-mail.')
  const path = String(brand?.garLogo || '').trim()
  let logo = ''
  if (path) {
    let url
    if (/^https?:\/\//i.test(path)) url = new URL(path).href
    else if (!/^[a-z][a-z\d+.-]*:/i.test(path)) {
      const base = new URL(apiBase, publicOrigin)
      if (!['http:', 'https:'].includes(base.protocol)) throw new Error('URL de imagens inválida.')
      url = `${base.href.replace(/\/$/, '')}/logo/GetFileByParam?param=${encodeURIComponent(path.replace(/\\/g, '/'))}`
    }
    if (url) logo = `<center><img src="${escapeHtml(url)}" alt="${escapeHtml(name)}" style="max-width: 200px;" /></center>`
  }
  let body = String(email.textoEmail || '')
  let systemUrl = publicOrigin
  const accessUrl = String(brand?.urlVisualizacao || '').trim()
  if (accessUrl) {
    const url = new URL(accessUrl)
    if (!['https:', 'http:'].includes(url.protocol)) throw new Error('URL de visualização inválida.')
    systemUrl = url.href.replace(/\/$/, '') + '/'
    // Insert the logo afterwards, keeping images on the ProcessAPI host.
    body = body.replaceAll(publicOrigin, () => escapeHtml(systemUrl))
  }
  return {
    ...email,
    nomeDe: !email.nomeDe || /^(GarantePay|\[NomeSistema\])$/i.test(email.nomeDe) ? name : email.nomeDe,
    assunto: replaceBrandText(email.assunto, name).replaceAll('[NomeSistema]', () => name),
    emailResposta: brand?.emailRemetente && (!email.emailResposta || email.emailResposta === defaultReply)
      ? brand.emailRemetente
      : email.emailResposta,
    textoEmail: replaceBrandText(body, name, true)
      .replaceAll('[LinkSistema]', () => escapeHtml(systemUrl))
      .replaceAll('[Logo]', () => logo)
      .replaceAll('[NomeSistema]', () => escapeHtml(name))
  }
}

export async function personalizarEmailGarantidora (email, garId, apiBase, publicOrigin, defaultReply) {
  const id = Number(garId)
  if (!Number.isSafeInteger(id) || id < 0) throw new Error('Garantidora inválida para o e-mail.')
  // Acesso administrativo sem vínculo não deve herdar a marca de outra sessão.
  const [brand, config] = await Promise.all([
    id === 0 ? Promise.resolve({ data: { garNomeEmpresa: 'GarantePay' } }) : axios.get(`/logo/GetLogo/${id}`, { skipAuthRedirect: true }),
    axios.get(`/logo/EmailConfig/${id}`, { skipAuthRedirect: true })
  ])
  return { ...buildGuarantorEmail(email, { ...brand.data, ...config.data }, apiBase, publicOrigin, defaultReply), garId: id || null }
}
